var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMana13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.28 -93.214)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6 0 0 6 3687.7 723.23)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -580,
    cy: -55.002,
    r: 50,
    fill: "#cac5c0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m135.52 211.96v291.26c0 34.242 14.568 51.33 43.692 51.33h6.894v19.932h-154.81v-19.932h9.978c29.628 0 44.436-17.088 44.436-51.33v-190.87c0-35.238-12.534-52.884-37.548-52.884h-15.348v-19.896h6.144c30.126 0 57.228-9.21 81.24-27.612h15.324zm130.3 193.15-9.198-16.878 6.918-3.846c22.986-14.274 44.322-28.71 63.996-43.29 19.644-14.556 29.502-31.02 29.502-49.428 0-12.774-4.866-23.388-14.562-31.806-9.702-8.448-20.46-12.654-32.184-12.654-29.658 0-60.816 17.892-93.528 53.67l-15.318-11.508c33.714-51.096 75.102-76.662 124.15-76.662 21.456 0 39.612 5.37 54.42 16.104 17.376 11.79 26.076 27.87 26.076 48.306 0 14.322-6.144 28.35-18.402 42.126-7.17 7.674-19.428 18.15-36.798 31.44l-6.894 6.138c3.06-0.49202 6.894-0.774 11.508-0.774 22.488 0 40.86 8.58 55.17 25.662 14.316 17.112 21.456 36.678 21.456 58.626 0 38.85-16.344 71.04-49.062 96.576-29.628 24.516-64.122 36.81-103.44 36.81-36.306 0-64.65-7.674-85.08-23.016l10.728-15.318c24.012 11.226 45.966 16.878 65.892 16.878 28.626 0 54.174-9.444 76.656-28.38 22.488-18.888 33.714-42.408 33.714-70.512 0-18.9-5.616-34.98-16.842-48.27-11.262-13.29-26.076-19.932-44.472-19.932-16.332 7e-3 -34.482 6.654-54.408 19.938z",
    fill: "#0d0f0f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMana13);
export default __webpack_public_path__ + "static/media/mana13.2b123307a288ebca21c1d765b284bc3a.svg";
export { ForwardRef as ReactComponent };